<template>
  <div class="star">
    <span
      ref="myCanvas"
      v-for="item in nums"
      :key="item"
      :style="{
        left: parseInt(Math.random() * screenW) + 'px',
        top:
          $store.state.isMobile == 'web'
            ? parseInt(Math.random() * heights) + 'px'
            : parseInt(Math.random() * heights) / 100 + 'rem',
        animationDelay: Math.random() + 's',
        transform: `scale(${(Math.random() / scalex + 0.01, Math.random() / scaley + 0.01)})`,
      }"
    >
      <img src="../assets/images/star.png" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'star',
  props: {
    nums: {
      type: Number,
      default: 120,
    },
    heights: {
      type: Number,
      default: 350,
    },
    scalex: {
      type: Number,
      default: 3,
    },
    scaley: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      screenW: window.innerWidth || document.documentElement.clientWidth,
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.star {
  position: absolute;
  top: 0.1rem;
  width: 100%;
  span {
    position: absolute;
    width: 0.15rem;
    height: 0.15rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: flash 1s alternate infinite;
  }

  @keyframes flash {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
</style>
